import axios from 'axios'
import store from '../store'
import router from '../router'
import { reportError, httpContextFromError } from '../utils/errorReporter'

const http = axios.create({
  baseURL: '/api/v1',
  withCredentials: true,
})

const PUBLIC_PATHS = ['/', '/login', '/signup', '/reset-password', '/privacy', '/terms']

function isPublicRoute(path) {
  return PUBLIC_PATHS.includes(path)
}

let handlingUnauthorized = false

export function clearAuthState() {
  store.commit('setUser', null)
  store.commit('setCompany', null)
}

export function redirectToLogin(redirectPath) {
  const currentPath = router.currentRoute.value.path
  if (currentPath === '/login' || currentPath === '/signup') {
    return
  }
  const redirect = redirectPath && redirectPath !== '/login' ? redirectPath : undefined
  router.push({
    path: '/login',
    query: redirect ? { redirect } : {},
  })
}

function handleUnauthorized(failedRequestPath) {
  if (handlingUnauthorized || isPublicRoute(window.location.pathname)) {
    return
  }
  handlingUnauthorized = true
  clearAuthState()
  redirectToLogin(failedRequestPath || router.currentRoute.value.fullPath)
  window.setTimeout(() => {
    handlingUnauthorized = false
  }, 500)
}

http.interceptors.response.use(
  (response) => response,
  (err) => {
    const status = err.response?.status
    const url = err.config?.url || ''
    if (status === 401) {
      if (!url.includes('/auth/v1/me')) {
        handleUnauthorized(router.currentRoute.value.fullPath)
      }
    } else if (status >= 500 && !String(url).includes('/errorreport/v1/ingest')) {
      // Safety net for 5xx that may never surface as a snackbar.
      reportError({
        kind: 'api_5xx',
        message: `API ${status} ${String(err.config?.method || 'GET').toUpperCase()} ${url}`,
        error: err,
        http: httpContextFromError(err),
      })
    }
    return Promise.reject(err)
  },
)

export default http
